// extracted by mini-css-extract-plugin
var _1 = "GretaAIChatComposer-moduleactions__PtzvI";
var _2 = "GretaAIChatComposer-modulecomposer__TxCgM";
var _3 = "GretaAIChatComposer-moduledisclaimer__FTIjv";
var _4 = "GretaAIChatComposer-moduleinput__NF7bq";
var _5 = "GretaAIChatComposer-moduleroot__PFRpQ";
var _6 = "GretaAIChatComposer-modulesourceSwitch__CiR1l GretaAIChatSourceSwitch-moduleswitch__rC5fk";
export { _1 as "actions", _2 as "composer", _3 as "disclaimer", _4 as "input", _5 as "root", _6 as "sourceSwitch" }
